/**
 * Uzbek strings of booking documents, the status re-check, the payment receipt, the deals export
 * and the supplier pricing (Wave 2). Spread into `uz`, so a key here is a `TranslationKey`.
 */
export const uzBookingsW2 = {
  "bookingW2.actions": "Amallar",
  "bookingW2.documents": "Hujjatlar",
  "bookingW2.documents.title": "Bron hujjatlari",
  "bookingW2.documents.empty": "Hujjat yo'q",
  "bookingW2.documents.kind": "Hujjat turi",
  "bookingW2.documents.kind.voucher": "Vaucher",
  "bookingW2.documents.kind.ticket": "Chipta",
  "bookingW2.documents.kind.insurance": "Sug'urta",
  "bookingW2.documents.file": "Fayl (JPG, PNG, WEBP yoki PDF, 10 MB gacha)",
  "bookingW2.documents.upload": "Yuklash",
  "bookingW2.documents.open": "Ochish",
  "bookingW2.documents.uploaded": "Hujjat yuklandi",
  "bookingW2.documents.failed": "Yuklab bo'lmadi",
  "bookingW2.documents.openFailed": "Hujjatni ochib bo'lmadi.",
  "bookingW2.check": "Holatni tekshirish",
  "bookingW2.check.moved": "Bron holati yangilandi: {status}.",
  "bookingW2.check.same": "Kabinetda: {status}. Bron holati o'zgarmadi.",
  "bookingW2.check.notFound": "Bu raqam turoperator kabinetida topilmadi.",
  "bookingW2.check.failed": "Tekshirib bo'lmadi.",
  "bookingW2.fromVariant": "Mijoz tanlagan variantdan to'ldirish",
  "bookingW2.fromVariant.done": "«{hotel}» varianti bo'yicha to'ldirildi.",

  "paymentW2.receipt": "Chek (rasm yoki PDF)",
  "paymentW2.receipt.open": "Chek",
  "paymentW2.receipt.failed": "Chekni ochib bo'lmadi.",

  "dealsW2.export": "Eksport",
  "dealsW2.export.failed": "Eksport qilib bo'lmadi.",

  "pricingW2.open": "Ustama va chegirma",
  "pricingW2.title": "{name}: ustama va chegirma",
  "pricingW2.hint": "Qoida shu turoperatorning keyingi qidiruv narxlariga qo'llanadi. Mijoz faqat sotuv narxini ko'radi.",
  "pricingW2.empty": "Qoida yo'q. Agentlikning umumiy ustamasi qo'llanadi.",
  "pricingW2.scope": "Yo'nalish",
  "pricingW2.scope.all": "Barcha yo'nalishlar",
  "pricingW2.method": "Ustama turi",
  "pricingW2.method.percent": "Foiz",
  "pricingW2.method.fixed_per_pax": "Odam boshiga summa",
  "pricingW2.value": "Ustama",
  "pricingW2.currency": "Valyuta",
  "pricingW2.discount": "Chegirma, %",
  "pricingW2.active": "Yoqilgan",
  "pricingW2.off": "O'chirilgan",
  "pricingW2.turnOff": "O'chirish",
  "pricingW2.turnOn": "Yoqish",
  "pricingW2.saved": "Qoida saqlandi",
  "pricingW2.failed": "Qoidani saqlab bo'lmadi.",
} as const;
